import React, { Fragment, useEffect, useRef, useState } from "react";
import {
  AppBar,
  Grid,
  TextField,
  Box,
  Paper,
  Tab,
  Tabs,
  Typography,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  withStyles,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  CardActions,
  ImageList,
  ImageListItem,
  FormControl,
} from "@material-ui/core";
import GetAppRoundedIcon from "@material-ui/icons/GetAppRounded";
import { useHistory, Link } from "react-router-dom";
import Autocomplete from "@material-ui/lab/Autocomplete";
import HttpService from "../../services/httpService";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { connect, useSelector } from "react-redux";
import { Modal } from "antd";
import moment from "moment";
import { CSVLink } from "react-csv";
import VisibilityRoundedIcon from "@material-ui/icons/VisibilityRounded";
import CenterFocusWeakIcon from "@material-ui/icons/CenterFocusWeak";
import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";
import { green, red, blue } from "@material-ui/core/colors";
import RepeatIcon from "@material-ui/icons/Repeat";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      marginTop: "2rem",
    },
  },
  table: {
    width: "fit-content",
    // width: "auto", /* or specify a fixed width */
    // min-width: '100%', /* Set a minimum width */
  },
  tablecontainer: {
    display: "flex",
    margin: "25px",
  },
  tableform: {
    display: "flex",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    marginBottom: "5rem",
  },
  clickableTableCell: {
    cursor: "pointer",
    textDecoration: "underline",
    color: "blue",
  },
  normalTableCell: {
    color: "black",
    "&:hover": {
      cursor: "pointer",
      color: "blue", // you can change the color when hovering here
      textDecoration: "underline",
    },
  },
  tableCell: {
    color: "blue",
    cursor: "pointer",
    textDecoration: "underline",
  },
  csv: {
    display: "flex",
    alignItems: "center",
    marginBottom: 20,
  },
  narrowTab: {
    minWidth: "fit-content", // Adjust the width as needed
    // width:"fit-content",
    width: 65,
  },
  margin: {
    margin: theme.spacing(1),
  },
  activeButton: {
    backgroundColor: "#F50057 !important",
    color: "white !important",
    transition: "background-color 0.3s, color 0.3s",
  },
  redButton: {
    backgroundColor: "#F50057 !important",
    color: "white !important",
    transition: "background-color 0.3s, color 0.3s",
    margin: "10px",
  },
  normalButton: {
    margin: "10px",
  },
  cardDialog: {
    minWidth: "80%",
    cursor: "default",
  },
  autoComplete: {
    width: "200px",
  },
  searchField: {
    marginTop: "20px",
    width: "800px",
  },
  viewIssueDialog: {
    minWidth: "80%",
  },
  imageList: {
    width: 500,
    // height: 450,
  },
  dialogMargin: {
    margin: "10px",
  },
  actionBar: { display: "flex", justifyContent: "center", gap: "10px" },
  iconHover: {
    transition: "filter 0.3s ease",
    filter: "brightness(1.3)",
  },
  reassign: {
    minWidth: "500px",
    // minHeight: "300px",
  },
  reassignAutocomplete: {
    margin: "20px",
  },
  editDialogue: {
    minWidth: "600px",
    cursor: "default",
  },
  dateSize: {
    width: "50%",
  },
  handOnHover: {
    cursor: "pointer",
  },
  remarks: {
    border: "1px solid black",
  },
  iconDisabledColor: {
    color: "rgb(255, 255, 255)",
  },
  leadSearchButton: {
    backgroundColor: "#b7ccf7",
    color: "#151921",
    padding: "1",
    marginRight: "0.5em",
    borderRadius: "20px",
    width: "20%",
    "&:hover": { backgroundColor: "#14419c", color: "white" },
  },
  leadClearButton: {
    backgroundColor: "#f7b7b7", // light red background
    color: "#151921",
    padding: "1",
    marginRight: "0.5em",
    borderRadius: "20px",
    width: "20%",
  },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#3F51B5",
    color: "#FFF",
    fontWeight: "500",
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const TaskManagementNotesDashBoard = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const { userDetails } = useSelector((state) => state.user);
  const [ribbonTagValue, setRibbonTagValue] = useState(
    "Tickets Assigned To Me"
  );
  const [fetchData, setFetchData] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [viewIssueDialog, setViewIssueDialog] = useState(false);
  const [viewConfirmationDialog, setViewConfirmationDialog] = useState(false);
  const [viewDeleteConfirmationDialog, setViewDeleteConfirmationDialog] =
    useState(false);
  const [viewIssueData, setViewIssueData] = useState({});
  const [closeIssueData, setCloseIssueData] = useState({});
  const [resolveIssueData, setResolveIssueData] = useState({});
  const [selectedStatusData, setSelectedStatusData] = useState("");
  const [searchTicketID, setSearchTicketID] = useState("");
  const [remarks, setRemarks] = useState("");
  const [ribbonNumberInfo, setRibbonNumberInfo] = useState({});
  const [deleteIssueData, setDeleteIssueData] = useState({});
  const [viewReassignIssueDialog, setViewReassignIssueDialog] = useState(false);
  const [viewEditIssueDialog, setViewEditIssueDialog] = useState(false);
  const [reassignIssueData, setReassignIssueData] = useState({});
  const [editIssueData, setEditIssueData] = useState({});
  const [editTicketTitle, setEditTicketTitle] = useState("");
  const [editTicketDes, setEditTicketDes] = useState("");
  const [editDueDate, setEditDueDate] = useState("");
  const [editFollowUpDate, setEditFollowUpDate] = useState("");
  const [createTicketFromNotes, setCreateTicketFromNotes] = useState(true);
  const [emailTag, setEmailTag] = useState("");
  const [isUserWithTeam, setIsUserWithTeam] = useState(true);
  const [categoryData, setCategoryData] = useState([
    "Pending",
    "Resolved",
    "Closed",
  ]);

  const csvButtonRef = useRef(null);
  const titleRef = useRef(null);
  const desciptionRef = useRef(null);

  const headers = [
    { key: "slno", label: "Sl No" },
    { key: "ticketNo", label: "Internal Ticket Id." },
    { key: "assignedTo", label: "Assigned To" },
    { key: "assignedBy", label: "Assigned By" },
    { key: "ticketCreatedDate", label: "Internal Ticket Created Date" },
    { key: "resolutionExpectedDate", label: "Resolution Expected Date" },
    { key: "daysPending", label: "Days Pending" },
    { key: "status", label: "Status" },
  ];

  // Function to handle tab changes
  const handleChange = (newValue) => {
    setRibbonTagValue(newValue);
  };

  const makeDataForCsv = (arr) => {
    let csvArrData = [];
    arr.forEach((el, i) => {
      let newObj = {
        slno: i + 1,
        ticketNo: el.uniqueTicketNo || "N/A",
        assignedTo: el.assignedTo?.name || "N/A",
        assignedBy: el.taskCreatedBy?.name || "N/A",
        ticketCreatedDate: el.createdAt
          ? moment(el.createdAt).format("DD-MM-YYYY")
          : "N/A",
        resolutionExpectedDate: el.expectedClosureDate
          ? moment(el.expectedClosureDate).format("DD-MM-YYYY")
          : "N/A",
        daysPending: el?.expectedClosureDate
          ? Math.ceil(
              (new Date(el?.expectedClosureDate) - new Date()) /
                (24 * 60 * 60 * 1000)
            )
          : "N/A",
        status: el.status || "N/A",
      };
      csvArrData.push(newObj);
    });
    setCsvData(csvArrData);
  };

  // Function to get Material Delivery Project's count loction based
  const getFilteredTickets = async (noDateArg) => {
    props.setLoading(true);
    try {
      let dateObj = {
        startDate: startDate,
        endDate: endDate,
      };

      if (noDateArg === "noDate") {
        dateObj.startDate = "";
        dateObj.endDate = "";
      }

      const response = await HttpService.getFilteredTaskTickets(
        ribbonTagValue,
        dateObj,
        selectedStatusData,
        createTicketFromNotes,
        userDetails?._id
      );
      setFetchData(response.data);
      makeDataForCsv(response.data);
    } catch (error) {
      console.log("Error ->", error);
    }
    props.setLoading(false);
  };

  const getDataOnPageLoading = async () => {
    props.setLoading(true);
    try {
      const response3 = await HttpService.getTaskRibbonNumberInfo(
        selectedStatusData,
        createTicketFromNotes,
        userDetails?._id
      );
      setRibbonNumberInfo(response3.data);
    } catch (error) {
      console.log("Error ->", error);
    }
    props.setLoading(false);
  };

  const handleDateFilter = () => {
    getFilteredTickets();
  };

  // get data without date filtering
  const clearFilterDate = () => {
    setStartDate("");
    setEndDate("");
    getFilteredTickets("noDate");
  };

  const viewIssue = (e, data, i) => {
    setViewIssueDialog(true);
    setViewIssueData(data);
  };

  const closeIssue = (e, data, i) => {
    setViewConfirmationDialog(true);
    setCloseIssueData(data);
  };

  const resolveIssue = (e, data, i) => {
    setViewConfirmationDialog(true);
    setResolveIssueData(data);
  };

  const deleteIssue = (e, data, i) => {
    setViewDeleteConfirmationDialog(true);
    setDeleteIssueData(data);
  };
  const reassignIssue = (e, data, i) => {
    setViewReassignIssueDialog(true);
    setReassignIssueData(data);
  };

  const editIssue = (e, data, i) => {
    setEditIssueData(data);
    setViewEditIssueDialog(true);
    setEditTicketTitle(data.ticketTitle);
    setEditTicketDes(data.ticketDescription);
  };

  const handleDialogClose = () => {
    setViewIssueDialog(false);
    setViewConfirmationDialog(false);
  };

  const handleEditDialogClose = () => {
    setViewEditIssueDialog(false);
  };

  const handleCloseConfirm = async () => {
    try {
      const response = await HttpService.closeTaskticket(closeIssueData._id, {
        remarks: remarks,
      });

      if (response.status === 200) {
        props.setSnackInfo("Internal Ticket Closed Succesfully", "Success");
        setViewConfirmationDialog(false);
        getDataOnPageLoading();
        getFilteredTickets();
        setViewConfirmationDialog(false);
      }
    } catch (err) {
      console.log(err);
      props.setSnackInfo(err.message, "Error");
    }
  };

  const handleResolveConfirm = async () => {
    try {
      const response = await HttpService.resolveTaskticket(
        resolveIssueData._id,
        { remarks: remarks }
      );

      if (response.status === 200) {
        props.setSnackInfo("Internal Ticket Resolved Succesfully", "Success");
        setViewDeleteConfirmationDialog(false);
        getDataOnPageLoading();
        getFilteredTickets();
        setViewConfirmationDialog(false);
      }
    } catch (err) {
      console.log(err);
      props.setSnackInfo(err.message, "Error");
    }
  };

  const handleDeleteConfirm = async () => {
    try {
      const response = await HttpService.deleteTaskTicket(deleteIssueData._id);

      if (response.status === 200) {
        props.setSnackInfo("Internal Ticket Deleted Succesfully", "Success");
        setViewConfirmationDialog(false);
        getDataOnPageLoading();
        getFilteredTickets();
        setViewDeleteConfirmationDialog(false);
      }
    } catch (err) {
      console.log(err);
      props.setSnackInfo(err.message, "Error");
    }
  };

  const onChangeTicketID = (e) => {
    setSearchTicketID(e.target.value);
  };

  const handleRemarksChange = (e) => {
    setRemarks(e.target.value);
  };

  const handleEditConfirm = async () => {
    try {
      const obj = {
        title: editTicketTitle,
        description: editTicketDes,
        ticketId: editIssueData._id,
        newDueDate: editDueDate,
        newFollowUpDate: editFollowUpDate,
      };

      const response = await HttpService.editTaskTicketDetails(obj);

      if (response.status === 200) {
        props.setSnackInfo("Success ", "success");
        getDataOnPageLoading();
        getFilteredTickets();
        setViewEditIssueDialog(false);
        setEditIssueData({});

        if (titleRef.current) {
          titleRef.current.value = ""; // Reset the input value to empty string
        }
        if (desciptionRef.current) {
          desciptionRef.current.value = ""; // Reset the input value to empty string
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleDownloadAttachments = async () => {
    viewIssueData.attachedFiles.forEach(
      async (item) => item !== "" && (await window.open(item))
    );
  };

  const searchByTicketId = async () => {
    props.setLoading(true);
    try {
      if (searchTicketID !== "") {
        const response = await HttpService.getSearchedTaskTicket(
          searchTicketID
        );

        setFetchData(response.data);
        makeDataForCsv(response.data);
        if (response.data.status === 204) {
          props.setSnackInfo("No results found", "error");
        }
      }
    } catch (err) {
      console.log(err.message);
      props.setSnackInfo(err.message, "Error");
    }
    props.setLoading(false);
  };

  //   console.log("fetch--",fetchData)

  const csvDownloadHandler = async () => {
    setLoading(true);
    try {
      downloadExcel();
    } catch (error) {
      console.log("error", error);
      props?.setSnackInfo(
        error?.response?.data?.message ?? "Something went wrong",
        "error"
      );
    }
    setLoading(false);
  };

  const downloadExcel = () => {
    setLoading(true);
    try {
      setTimeout(() => {
        csvButtonRef.current.link.click();
      });
    } catch (err) {
      console.error(err.message);
    }
    setLoading(false);
  };

  const handleReassignIssueConfirm = async () => {
    try {
      const response = await HttpService.changeTaskTicketAssignedUserFromEmail(
        reassignIssueData._id,
        emailTag
      );
      if (response.status == 200) {
        props.setSnackInfo("Success ", "success");
        getDataOnPageLoading();
        getFilteredTickets();
        setViewReassignIssueDialog(false);
      }
    } catch (error) {
      console.log("error is ", error);
      if (error.response.status == 400) {
        props.setSnackInfo(error.response.data, "error");
      } else {
        props.setSnackInfo("Error occoured", "error");
      }
    }
  };

  const handleEditDueDateChange = (e) => {
    const selectedDate = new Date(e.target.value);
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);

    // Check if the selected date is in the future or today
    if (selectedDate >= currentDate) {
      setEditDueDate(e.target.value);
    } else {
      props.setSnackInfo(
        "Please select a date in the present or future.",
        "warning"
      );
    }
  };

  const handleEmailTagChange = (e, v) => {
    setEmailTag(e.target.value.toLowerCase());
  };

  const checkUserWithoutTeam = () => {
    // set false for executives
    const singleRoleNames = [
      "Design User",
      "Sales User",
      "Finance User",
      "CHM_User",
      "Procurement Executive",
      "Finance Executive",
      "BOM Executive",
      "Marketing User",
      "Factory Bom",
      "CRM Factory",
      "Factory CRM",
      "Execution User",
      "LnD_User",
      "IMOS User",
      "Vendor Executive",
      "TeleCaller",
      "Project Manager",
      "Factory Finance Executive",
    ];

    if (
      userDetails.roles.length === 1 &&
      singleRoleNames.includes(userDetails.roles[0].name)
    ) {
      setIsUserWithTeam(false);
    }
  };

  // get data on ribbon filter change
  useEffect(() => {
    getFilteredTickets();
    getDataOnPageLoading();
  }, [ribbonTagValue, selectedStatusData]);

  useEffect(() => {
    getDataOnPageLoading();
    checkUserWithoutTeam();
  }, []);

  return (
    <Fragment>
      <div>
        <Paper className={classes.paper}>
          <>
            <Grid
              container
              spacing={2}
              justifyContent="center"
              alignItems="center"
            >
              <Grid item xs={12} sm={3}>
                <TextField
                  id="date"
                  name="startDate"
                  label="Start Date"
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  id="date"
                  name="endDate"
                  label="End Date"
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!startDate || !endDate}
                  onClick={handleDateFilter}
                  style={{
                    backgroundColor: "#F50057",
                    color: "#fff",
                    padding: "0.4rem 2rem",
                  }}
                >
                  Submit
                </Button>
              </Grid>

              <Grid item xs={12} sm={2}>
                <CSVLink
                  headers={headers}
                  filename={ribbonTagValue + ".csv"}
                  data={csvData}
                  ref={csvButtonRef}
                />
                <Button
                  onClick={csvDownloadHandler}
                  style={{
                    marginLeft: 20,
                    backgroundColor: "green",
                    color: "white",
                    height: 35,
                  }}
                  variant="contained"
                  color="success"
                >
                  Download CSV
                </Button>
              </Grid>
            </Grid>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                marginTop: "30px",
              }}
            >
              {/* Search Type Dropdown */}
              <Autocomplete
                value={selectedStatusData}
                key="selectedStatusData"
                size="small"
                onChange={(e, newValue) => setSelectedStatusData(newValue)}
                options={categoryData}
                getOptionLabel={(option) => option}
                style={{ width: "30%", marginRight: "2%" }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Tag Status"
                    variant="outlined"
                  />
                )}
              />

              {/* Search Input */}
              <TextField
                size="small"
                variant="outlined"
                style={{ width: "80%" }}
                id="ticketIdSearch"
                name="ticketIdSearch"
                label="Search Internal Tickets(Internal Ticket ID)"
                type="string"
                value={searchTicketID}
                onChange={onChangeTicketID}
                InputLabelProps={{
                  shrink: true,
                }}
              />

              {/* Search Button */}
              <Button
                variant="contained"
                color="primary"
                size="medium"
                style={{ alignSelf: "center", marginLeft: 20 }}
                className={classes.leadSearchButton}
                id="search-btn"
                onClick={searchByTicketId}
                disabled={searchTicketID === ""}
              >
                Search
              </Button>

              {/* Clear Filter Button */}
              <Button
                variant="contained"
                color="secondary"
                size="medium"
                style={{ marginLeft: 10 }}
                className={classes.leadClearButton}
                onClick={clearFilterDate}
              >
                Clear Filter
              </Button>
            </div>
            <Fragment>
              <div className={classes.root}>
                <Fragment>
                  <Button
                    variant="outlined"
                    color="primary"
                    size="medium"
                    onClick={() => handleChange("Tickets Assigned To Me")}
                    className={
                      ribbonTagValue === "Tickets Assigned To Me"
                        ? classes.activeButton
                        : ""
                    }
                  >
                    Internal Tickets Assign to Me({ribbonNumberInfo.toMe})
                  </Button>
                </Fragment>

                {isUserWithTeam && (
                  <Fragment>
                    <Button
                      variant="outlined"
                      color="primary"
                      size="medium"
                      onClick={() =>
                        handleChange("Tickets Assigned To My Team")
                      }
                      className={
                        ribbonTagValue === "Tickets Assigned To My Team"
                          ? classes.activeButton
                          : ""
                      }
                    >
                      Internal Tickets Assigned to My Team(
                      {ribbonNumberInfo.toTeam})
                    </Button>
                  </Fragment>
                )}

                <Fragment>
                  <Button
                    variant="outlined"
                    color="primary"
                    size="medium"
                    onClick={() => handleChange("Tickets Assigned By Me")}
                    className={
                      ribbonTagValue === "Tickets Assigned By Me"
                        ? classes.activeButton
                        : ""
                    }
                  >
                    Internal Tickets Assigned by Me({ribbonNumberInfo.byMe})
                  </Button>
                </Fragment>
              </div>
            </Fragment>
          </>
        </Paper>
      </div>

      {fetchData && (
        <TableContainer component={Paper} className={classes.table}>
          <Table
            className={classes.table}
            stickyHeader
            aria-label="sticky table"
          >
            <TableHead style={{ backgroundColor: "red", color: "white" }}>
              <StyledTableRow key="tableHeaders">
                <StyledTableCell style={{ textAlign: "center" }}>
                  Sl. No.
                </StyledTableCell>
                <StyledTableCell style={{ textAlign: "center" }}>
                  Internal Ticket Id.
                </StyledTableCell>
                <StyledTableCell style={{ width: "25%", textAlign: "center" }}>
                  Ticket Title
                </StyledTableCell>
                <StyledTableCell style={{ textAlign: "center" }}>
                  Assigned To
                </StyledTableCell>
                <StyledTableCell style={{ textAlign: "center" }}>
                  Assigned by
                </StyledTableCell>
                <StyledTableCell style={{ textAlign: "center" }}>
                  Created On
                </StyledTableCell>
                <StyledTableCell style={{ textAlign: "center" }}>
                  Due Date
                </StyledTableCell>
                {!(ribbonTagValue === "Closed") && (
                  <StyledTableCell style={{ textAlign: "center" }}>
                    Days pending
                  </StyledTableCell>
                )}
                <StyledTableCell style={{ textAlign: "center" }}>
                  Status
                </StyledTableCell>
                <StyledTableCell style={{ textAlign: "center" }}>
                  Action
                </StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {fetchData?.map((data, i) => {
                return (
                  <StyledTableRow key={i}>
                    <StyledTableCell component="th">{i + 1}</StyledTableCell>

                    <StyledTableCell
                      component="th"
                      style={{ textAlign: "center" }}
                    >
                      {data?.uniqueTicketNo || "N/A"}
                    </StyledTableCell>

                    <StyledTableCell
                      component="th"
                      style={{ textAlign: "center" }}
                    >
                      {data?.ticketTitle || "N/A"}
                    </StyledTableCell>

                    <StyledTableCell
                      component="th"
                      style={{ textAlign: "center" }}
                    >
                      {data?.assignedTo?.name || "N/A"}
                    </StyledTableCell>

                    <StyledTableCell
                      component="th"
                      style={{ textAlign: "center" }}
                    >
                      {data?.taskCreatedBy?.name || "N/A"}
                    </StyledTableCell>

                    <StyledTableCell
                      component="th"
                      style={{ textAlign: "center" }}
                    >
                      {data?.createdAt
                        ? moment(data?.createdAt).utc().format("DD-MM-YYYY")
                        : "-"}
                    </StyledTableCell>

                    <StyledTableCell
                      component="th"
                      style={{ textAlign: "center" }}
                    >
                      {data?.expectedClosureDate
                        ? moment(data?.expectedClosureDate)
                            .utc()
                            .format("DD-MM-YYYY")
                        : "-"}
                    </StyledTableCell>

                    {!(ribbonTagValue === "Closed") && (
                      <StyledTableCell
                        component="th"
                        style={{ textAlign: "center" }}
                      >
                        {data?.expectedClosureDate
                          ? // Check if expectedClosureDate is a valid date
                            Math.ceil(
                              (new Date(data?.expectedClosureDate) -
                                new Date()) /
                                (24 * 60 * 60 * 1000)
                            )
                          : "N/A"}
                      </StyledTableCell>
                    )}

                    <StyledTableCell
                      component="th"
                      style={{ textAlign: "center" }}
                    >
                      {data?.status || "N/A"}
                    </StyledTableCell>

                    <StyledTableCell
                      component="th"
                      style={{ textAlign: "center" }}
                    >
                      <div className={classes.actionBar}>
                        <VisibilityRoundedIcon
                          className={classes.handOnHover}
                          style={{ color: green[500] }}
                          onClick={(e) => {
                            viewIssue(e, data, i);
                          }}
                          titleAccess="View Issue"
                        />

                        {ribbonTagValue === "Tickets Assigned By Me" &&
                          data?.status === "Resolved" && (
                            <CenterFocusWeakIcon
                              className={classes.handOnHover}
                              style={{ color: blue[500] }}
                              onClick={(e) => {
                                closeIssue(e, data, i);
                              }}
                              titleAccess="Close Issue"
                            />
                          )}

                        {ribbonTagValue === "Tickets Assigned To Me" &&
                          !(
                            data?.status === "Closed" ||
                            data?.status === "Resolved"
                          ) && (
                            <CenterFocusWeakIcon
                              className={classes.handOnHover}
                              style={{ color: blue[500] }}
                              onClick={(e) => {
                                resolveIssue(e, data, i);
                              }}
                              titleAccess="Resolve Issue"
                            />
                          )}

                        {ribbonTagValue === "Tickets Assigned By Me" && (
                          <DeleteOutlineRoundedIcon
                            className={classes.handOnHover}
                            style={{ color: red[500] }}
                            onClick={(e) => {
                              deleteIssue(e, data, i);
                            }}
                            titleAccess="Delete Issue"
                          />
                        )}
                        {ribbonTagValue === "Tickets Assigned By Me" && (
                          <RepeatIcon
                            className={classes.handOnHover}
                            style={{ color: blue[500] }}
                            onClick={(e) => {
                              reassignIssue(e, data, i);
                            }}
                            titleAccess="Reassign Issue"
                          />
                        )}

                        {ribbonTagValue === "Tickets Assigned By Me" && (
                          <EditOutlinedIcon
                            className={classes.handOnHover}
                            style={{ color: red[500] }}
                            onClick={(e) => {
                              editIssue(e, data, i);
                            }}
                            titleAccess="Edit Issue"
                          />
                        )}
                      </div>
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <Fragment>
        <Dialog
          open={viewIssueDialog}
          keepMounted
          onClose={handleDialogClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          className={classes.viewIssueDialog}
        >

                <div style={{ marginBottom: "20px" }}></div>
                <span
                  style={{
                    fontWeight: "100",
                    textAlign: "center",
                    fontSize: "25px",
                    marginRight: "10px",
                  }}
                >
                  Title:
                </span>
                <span style={{ fontSize: "15px" }}>
                  {viewIssueData.ticketTitle}
                </span>
                <div style={{ marginBottom: "20px" }}></div>
                <span
                  style={{
                    fontWeight: "100",
                    textAlign: "center",
                    fontSize: "25px",
                    marginRight: "10px",
                  }}
                >
                  Description:
                </span>
                <span style={{ fontSize: "15px" }}>
                  {viewIssueData.ticketDescription}
                </span>
                <div style={{ marginBottom: "20px" }}></div>
                <ImageList
                  rowHeight={160}
                  className={classes.imageList}
                  cols={3}
                >
                  {viewIssueData?.attachedFiles?.length > 0 &&
                    viewIssueData.attachedFiles.map(
                      (item) =>
                        (item.endsWith(".jpg") ||
                          item.endsWith(".png") ||
                          item.endsWith(".jpeg")) && (
                          <ImageListItem key={item} cols={1}>
                            <img src={item} alt={"img not found"} />
                          </ImageListItem>
                        )
                    )}
                </ImageList>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="h2"
                    style={{ marginTop: 10, marginRight: 10 }}
                  >
                    Download Attachments
                  </Typography>
                  <GetAppRoundedIcon
                    onClick={handleDownloadAttachments}
                    className={
                      viewIssueData?.attachedFiles?.length > 0 &&
                      viewIssueData?.attachedFiles[0] === ""
                        ? classes.iconDisabledColor
                        : {}
                    }
                  />
                </div>

                <Typography
                  gutterBottom
                  variant="h5"
                  component="h2"
                  style={{ marginTop: 10 }}
                >
                  Remarks
                </Typography>

                {viewIssueData?.logs?.length > 0 && (
                  <TableContainer key="remarksTable" component={Paper}>
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <StyledTableRow key="tableHeaders">
                          <StyledTableCell>Sl. No.</StyledTableCell>
                          <StyledTableCell>Remarks</StyledTableCell>
                          <StyledTableCell>From</StyledTableCell>
                          <StyledTableCell>Created On</StyledTableCell>
                        </StyledTableRow>
                      </TableHead>
                      <TableBody>
                        {viewIssueData.logs.map((log, i) => (
                          <StyledTableRow key={i}>
                            <StyledTableCell component="th">
                              {i + 1}
                            </StyledTableCell>

                            <StyledTableCell
                              component="th"
                              style={{ textAlign: "center" }}
                            >
                              {log?.remarks || "-"}
                            </StyledTableCell>

                            <StyledTableCell
                              component="th"
                              style={{ textAlign: "center" }}
                            >
                              {log?.createdBy?.name || "N/A"}
                            </StyledTableCell>

                            <StyledTableCell
                              component="th"
                              style={{ textAlign: "center" }}
                            >
                              {log?.createdOn
                                ? moment(log?.createdOn)
                                    .utc()
                                    .format("DD-MM-YYYY")
                                : "-"}
                            </StyledTableCell>
                          </StyledTableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
        </Dialog>
      </Fragment>

      <Fragment>
        <Dialog
          open={viewConfirmationDialog}
          // TransitionComponent={Transition}
          keepMounted
          onClose={handleDialogClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <Card className={classes.root}>
            <CardActionArea className={classes.cardDialog}>
              <CardContent className={classes.cardDialog}>
                <span
                  style={{
                    fontWeight: "100",
                    textAlign: "center",
                    fontSize: "20px",
                    marginRight: "10px",
                  }}
                >
                  Internal Ticket Id:
                </span>
                <span style={{ fontSize: "15px" }}>
                  {resolveIssueData?.uniqueTicketNo}
                </span>
                <div style={{ marginBottom: "20px" }}></div>
                <span
                  style={{
                    fontWeight: "100",
                    textAlign: "center",
                    fontSize: "20px",
                    marginRight: "10px",
                  }}
                >
                  Title:
                </span>
                <span style={{ fontSize: "15px" }}>
                  {resolveIssueData?.ticketTitle}
                </span>
                <div style={{ marginBottom: "20px" }}></div>

                <Typography gutterBottom variant="h6" component="h2">
                  Confirmation
                </Typography>

                {ribbonTagValue === "Tickets Assigned By Me" && (
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="p"
                  >
                    Are you sure you want to close this Internal Ticket
                  </Typography>
                )}

                {ribbonTagValue === "Tickets Assigned To Me" && (
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="p"
                  >
                    Click confirm to Resolve this Internal Ticket
                  </Typography>
                )}
              </CardContent>
            </CardActionArea>

            <CardActions>
              <TextField
                id="remarks"
                name="remarks"
                label="Remarks"
                type="string"
                value={remarks}
                onChange={handleRemarksChange}
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth
                className={classes.textField}
              />
            </CardActions>

            <CardActions>
              <Button
                variant="outlined"
                color="primary"
                size="small"
                onClick={handleDialogClose}
                className={
                  ribbonTagValue === "Category" ? classes.activeButton : ""
                }
              >
                Cancel
              </Button>

              {ribbonTagValue === "Tickets Assigned By Me" && (
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  onClick={handleCloseConfirm}
                  className={
                    ribbonTagValue === "Category" ? classes.activeButton : ""
                  }
                >
                  Confirm
                </Button>
              )}
              {ribbonTagValue === "Tickets Assigned To Me" && (
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  onClick={handleResolveConfirm}
                  className={
                    ribbonTagValue === "Category" ? classes.activeButton : ""
                  }
                >
                  Confirm
                </Button>
              )}
            </CardActions>
          </Card>
        </Dialog>
      </Fragment>
      <Fragment>
        <Dialog
          open={viewDeleteConfirmationDialog}
          // TransitionComponent={Transition}
          keepMounted
          onClick={() => {
            setViewDeleteConfirmationDialog(false);
          }}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <Card className={classes.root}>
            <CardActionArea className={classes.cardDialog}>
              <CardContent className={classes.cardDialog}>
                <Typography gutterBottom variant="h6" component="h2">
                  Confirmation
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  Are you sure you want to delete this Internal Ticket
                </Typography>
              </CardContent>
            </CardActionArea>

            <CardActions>
              <Button
                variant="outlined"
                color="primary"
                size="small"
                onClick={() => {
                  setViewDeleteConfirmationDialog(false);
                }}
                className={
                  ribbonTagValue === "Category" ? classes.activeButton : ""
                }
              >
                Cancel
              </Button>

              <Button
                variant="outlined"
                color="primary"
                size="small"
                onClick={handleDeleteConfirm}
                className={
                  ribbonTagValue === "Category" ? classes.activeButton : ""
                }
              >
                Delete
              </Button>
            </CardActions>
          </Card>
        </Dialog>

        <Dialog
          open={viewReassignIssueDialog}
          keepMounted
          onClose={() => {
            setViewReassignIssueDialog(false);
          }}
        >
          <Grid
            container
            className={classes.reassign}
            direction="column"
            justifyContent="space-evenly"
            alignItems="stretch"
            key="ReassignGridContainer"
          >
            <h3 className={classes.tablecontainer}>Enter User Email</h3>
            <TextField
              id="emailTagging"
              name="Tag Email"
              type="email"
              variant="outlined"
              onChange={(e, v) => handleEmailTagChange(e, v)}
              value={emailTag}
              className={classes.reassignAutocomplete}
            ></TextField>
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="space-evenly"
            alignItems="center"
          >
            <Button
              variant="outlined"
              color="primary"
              size="small"
              onClick={() => {
                setViewReassignIssueDialog(false);
              }}
              className={classes.redButton}
            >
              Cancel
            </Button>

            <Button
              variant="outlined"
              color="primary"
              size="small"
              onClick={handleReassignIssueConfirm}
              className={classes.normalButton}
            >
              Confirm
            </Button>
          </Grid>
        </Dialog>
      </Fragment>

      <Fragment>
        <Dialog
          open={viewEditIssueDialog}
          keepMounted
          onClose={handleEditDialogClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          className={classes.editDialogue}
        >
          <Card className={classes.editDialogue}>
            <CardActionArea className={classes.cardDialog}>
              <CardContent className={classes.cardDialog}>
                <Typography gutterBottom variant="h5" component="h2">
                  New Title
                </Typography>

                <TextField
                  id="editTicketTitle"
                  inputRef={titleRef}
                  value={editTicketTitle}
                  variant="outlined"
                  className={classes.margin}
                  onChange={(e) => setEditTicketTitle(e.target.value)}
                ></TextField>

                <Typography gutterBottom variant="h5" component="h2">
                  New Description
                </Typography>
                <TextField
                  id="editTicketDescription"
                  value={editTicketDes}
                  inputRef={desciptionRef}
                  variant="outlined"
                  className={classes.margin}
                  onChange={(e) => setEditTicketDes(e.target.value)}
                ></TextField>

                <div></div>
                <TextField
                  id="date"
                  name="dueDate"
                  label="Due Date"
                  type="date"
                  value={editDueDate}
                  onChange={handleEditDueDateChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                  className={classes.margin + " " + classes.dateSize}
                />

                <CardActions>
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    onClick={() => setViewEditIssueDialog(false)}
                    className={classes.activeButton}
                  >
                    Cancel
                  </Button>

                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    onClick={handleEditConfirm}
                    className={
                      ribbonTagValue === "Category" ? classes.activeButton : ""
                    }
                  >
                    Update
                  </Button>
                </CardActions>
              </CardContent>
            </CardActionArea>
          </Card>
        </Dialog>
      </Fragment>
    </Fragment>
  );
};

export default connect(null, { setLoading, setSnackInfo })(
  TaskManagementNotesDashBoard
);